import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function PresupuestadorDeEnvios() {
  return (
    <ClipperPlaceholder title="Presupuestador de Envíos" category="Operativas" />
  );
}
